/* eslint-disable no-unused-vars */
/**
 * Class representation of `calls.cadence` generated by modified version of typeorm-model-generator.
 *
 * @description Created with the following options (list not exhaustive - only pertains to entity options):
 *  --cascade 'true', --generateConstructor, --generateTinyintTransformer, --generateValidators, --smartStrictMode, --omitTypeorm,
 */
// TODO: Fix race condition. If comment below is removed then class-validator column decorators will not match import statement.
// import {} from "typeorm";

/* eslint-disable no-unused-vars */
import {
  IsIn,
  IsNotEmpty,
  IsNumber,
  IsNumberString,
  IsOptional,
  MaxLength,
} from "class-validator";
/* eslint-enable no-unused-vars */

import { ISchedulableHours } from "../interfaces/ISchedulableHours";
import { Business } from "./Business";
import { CadenceAction } from "./CadenceAction";
import { CadenceDispositionRule } from "./CadenceDispositionRule";
import { CadenceHarassmentPolicy } from "./CadenceHarassmentPolicy";
import { CadenceProcess } from "./CadenceProcess";

export class Cadence {
  @IsNumber()
  @IsOptional()
  cadenceId?: number;

  @IsNumberString()
  @IsOptional()
  businessId?: string;

  @IsIn(["active", "inactive", "deleted"])
  @IsOptional()
  status?: "active" | "inactive" | "deleted";

  @MaxLength(255)
  @IsNotEmpty()
  cadenceName!: string;

  @MaxLength(255)
  @IsNotEmpty()
  eventUrl!: string;

  @IsNotEmpty()
  checkDncEnabled!: boolean;

  @IsNotEmpty()
  reEnrollmentEnabled!: boolean;

  @IsNotEmpty()
  useContactOwnerEnabled!: boolean;

  @IsIn(["assignFromQueueOnAnswer", "autoAssignFromQueue"])
  @IsOptional()
  assignContactOwner?: "assignFromQueueOnAnswer" | "autoAssignFromQueue";

  @IsNumber()
  @IsOptional()
  version?: number;

  @IsNumberString()
  @IsOptional()
  queueId?: string | null;

  @IsNotEmpty()
  cadenceHours!: ISchedulableHours;

  @IsNotEmpty()
  targetHours!: ISchedulableHours;

  @IsOptional()
  updatedDate?: Date;

  @IsOptional()
  createdDate?: Date;

  @IsOptional()
  useBusinessHarassmentPolicyEnabled?: boolean;

  @IsOptional()
  useBusinessCadenceHoursEnabled?: boolean;

  @IsOptional()
  useBusinessTargetHoursEnabled?: boolean;

  business?: Business;

  cadenceActions?: CadenceAction[];

  cadenceDispositionRules?: CadenceDispositionRule[];

  cadenceHarassmentPolicies?: CadenceHarassmentPolicy[];

  cadenceProcesses?: CadenceProcess[];
  smsSender?: string;
  smsInboxId?: string;
  smsBusinessNumber?: string;

  constructor(init?: Partial<Cadence>) {
    Object.assign(this, init);
  }
}
